import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import PackageHeader from '../components/PackageHeader';
import NotFoundPage from './NotFoundPage';

@inject('packageStore')
@observer
export default class PackageShop extends Component {
  
  componentWillMount() {
    this.setPackageInfo();
  }

  setPackageInfo() {
    const {
      packageStore: {
        setPackageInfo:setPackageInfoInStore,
        setShopGroups:setShopGroupsInStore,
      },
      location,
    } = this.props;
    const pathname = location.pathname;
    const barcode = pathname.split('/')[2];

    setPackageInfoInStore(barcode);
    setShopGroupsInStore(barcode);
  }

  getStateStyle = (state) => {
    let stateClass = '';

    switch (state) {
      case 'A':
        stateClass = 'txt-used'; 
        break;
      case 'AR':
        stateClass = 'txt-using'; 
        break;
      case 'E':
        stateClass = 'txt-use'; 
        break;
      default:
        stateClass = 'txt-disabled'; 
    }
    
    return stateClass;
  };

  renderShopList = (shopGroup, barcode, title) => {
    if (_.isEmpty(shopGroup)) return;
    
    const baseTicketLink = `/tickets/${barcode}`;
    const TicketList = _.map(shopGroup, (shop, index) => {
        const {
          shopSeq,
          shopNm,
          status,
          statusLabel,
          hasReserve,
          hasTicket
        } = shop;

        const stateCssClass = this.getStateStyle(status);

        if(hasReserve) {
          return(
              <div key={index}>
                <a className="btn-package" style={{
                  borderRadius: '0',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  borderBottom: 0,
                  marginBottom: 0
                }}>
                  <div>
                    <span className="number-package">{index + 1}</span>
                    <h3 className="name-package">{shopNm}</h3>
                    <span className={`txt-state ${stateCssClass}`}>{statusLabel}</span>
                  </div>
                </a>
                <div style={{
                  display: 'flex',
                  height: '50px',
                  marginBottom: '10px',
                  border: '1px solid #d8d8d8',
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                  textAlign: 'center',
                  alignContent: 'center'
                }}>{hasTicket &&
                    <Link
                        style={{ flex: 1, lineHeight: '50px', borderRight: '1px solid #d8d8d8', color: '#545454' }}
                        to={`${baseTicketLink}?shopSeq=${shopSeq}`}
                    >
                      <div>티켓 페이지로</div>
                    </Link>
                  }
                  <Link
                      style={{ flex: 1, lineHeight: '50px', borderRight: '1px solid #d8d8d8', color: '#545454' }}
                      to={`${baseTicketLink}/reserve?shopSeq=${shopSeq}`}
                  >
                    <div style={{ flex: 1, lineHeight: '50px', color: '#545454' }}>티켓 예약 페이지로</div>
                  </Link>
                </div>
              </div>
          )
        }

        return(
            <div key={index}>
              <a className="btn-package" style={{
                borderRadius: '0',
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px',
                borderBottom: 0,
                marginBottom: 0
              }}>
                <div>
                  <span className="number-package">{index + 1}</span>
                  <h3 className="name-package">{shopNm}</h3>
                  <span className={`txt-state ${stateCssClass}`}>{statusLabel}</span>
                </div>
              </a>
              <div style={{
                display: 'flex',
                height: '50px',
                marginBottom: '10px',
                border: '1px solid #d8d8d8',
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                textAlign: 'center',
                alignContent: 'center'
              }}>
                  <Link
                      style={{ flex: 1, lineHeight: '50px', borderRight: '1px solid #d8d8d8', color: '#545454' }}
                      to={`${baseTicketLink}?shopSeq=${shopSeq}`}
                  >
                    <div>티켓 페이지로</div>
                  </Link>
              </div>
            </div>
        );

        // return (
        //   <Link
        //     to={`${baseTicketLink}?shopSeq=${shopSeq}`}
        //     className="btn-package"
        //     key={index}
        //   >
        //     <span className="number-package">{index + 1}</span>
        //     <h3 className="name-package">{shopNm}</h3>
        //     <span className={`txt-state ${stateCssClass}`}>{statusLabel}</span>
        //   </Link>
        // )
    });

    if(title === 'available') {
      return (
        <div className="group-packages">
          {TicketList}
        </div>
      )
    }
    
    if(title === 'done') {
      return (
        <div className="group-packages packages-end">
          <h2 className="title-package">사용완료 이용권</h2>
          {TicketList}
        </div>
      )
    }
  }

  render() {
    const {
      packageStore: {
        barcode,
        packageInfo,
        shopGroups,
      },
    } = this.props;

    if (_.isEmpty(shopGroups) || _.isEmpty(packageInfo)) {
      return <NotFoundPage />;
    }

    const { available, done } = shopGroups;

    return (
      <div className="App Package">
        <PackageHeader tab="shop" />
        <div className="info-message">
          방문하실 관광지를 선택 후 매표소에 제시해 주세요.
        </div>
        <div className="App-container fade">
          {
            available.length > 0
            ? this.renderShopList(available, barcode, 'available')
            : null
          }
          {
            done.length > 0
            ? this.renderShopList(done, barcode, 'done')
            : null
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PackageShop.jsx